/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useRef } from 'react';
import { apiUrl } from "../constants/constants";


export const fetchAndReceiveJSON = async ({ url, method, body }) => {
    if (method === 'GET') {
        const res = await fetch(url, { method: 'GET', credentials: 'include' });
        if ((await res.status) !== 200) {
            const resBody = await res.json();
            // alert(resBody.message);
            return false;
        }
        try {
            const data = await res.json();
            return data;
        } catch (err) {
            return false;
        }
    } else if (method === 'POST') {
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (res.status !== 200) {
            const resBody = await res.json();
            if (res.status === 400) {
                if (url.includes('/api/login')) {
                    return resBody.message;
                } else if (url.includes('/api/cart/item/add')) {
                    return resBody.status
                } else if (url.includes('/api/signup')) {
                    return resBody.status
                } else {
                    alert(resBody.message);
                    return false;
                }
            } else if (res.status === 401) {
                if (url.includes('/api/cart/item/add')) {
                    return resBody.status
                }
            }
            // alert(resBody.message);
            return false;
        }
        try {
            const data = await res.json();
            return data;
        } catch (err) {
            // alert(err)
            console.log(err);
            return false;
        }
    }
};

export const parseDate = (date) => {
    let parsedDate = `${date.substr(0, 4)}.${date.substr(5, 2)}.${date.substr(8, 2)}`;

    return parsedDate;
};

export const parseDateAndTime = (date) => {
    let parsedDate = `${date.substr(0, 4)}.${date.substr(5, 2)}.${date.substr(8, 2)} ${date.substr(
        11,
        5
    )}`;
    return parsedDate;
};

export const wordCut = (word, cnt) => {
    return `${word.substr(0, cnt)}...`;
};

export const moveScrollToId = (id) => {
    let target = document.getElementById(id);
    if (target) {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: target.offsetTop,
        });
    }
};

export const moveToAnchor = (delay = 0) => {
    let curUrl = window.location.href.split('#');
    let position = curUrl[curUrl.length - 1];
    if (curUrl.length === 1) {
        return;
    }

    if (delay) {
        setTimeout(() => {
            moveScrollToId(position);
        }, delay);
        return;
    }
    if (position) {
        moveScrollToId(position);
        return;
    }
};

// overlay.html의 키눌림 감지코드와 같이 써야 함
export const moveToLink = (url, e = undefined) => {
    if (e) {
        if (e.metaKey || e.ctrlKey) {
            window.open(url);
            return;
        }
        // else window.location = url;
    }
    window.location.href = url;
};

export const moveToLinkNewWindow = (url) => {
    window.open(url)
}

export const srollInsideElem = (element, to, duration) => {
    var easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    var start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    var animateScroll = function () {
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
};

export const autoHypenPhone = (str) => {
    str = str.replace(/[^0-9]/g, '');
    var tmp = '';
    if (str.length < 4) {
        return str;
    } else if (str.length < 7) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3);
        return tmp;
    } else if (str.length < 11) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 3);
        tmp += '-';
        tmp += str.substr(6);
        return tmp;
    } else {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 4);
        tmp += '-';
        tmp += str.substr(7, 4);
        return tmp;
    }
};

export const autoHypenCorpNum = (str) => {
    str = str.replace(/[^0-9]/g, '');
    var tmp = '';
    if (str.length < 4) {
        return str;
    } else if (str.length < 6) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3);
        return tmp;
    } else if (str.length < 11) {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 2);
        tmp += '-';
        tmp += str.substr(5);
        return tmp;
    } else {
        tmp += str.substr(0, 3);
        tmp += '-';
        tmp += str.substr(3, 2);
        tmp += '-';
        tmp += str.substr(5, 5);
        return tmp;
    }
};

export const checkImgFormat = (src) => {
    if (
        src.indexOf('.jpg') !== -1 ||
        src.indexOf('.jpeg') !== -1 ||
        src.indexOf('.png') !== -1 ||
        src.indexOf('.JPG') !== -1 ||
        src.indexOf('.JPEG') !== -1 ||
        src.indexOf('.PNG') !== -1
    ) {
        return true;
    } else {
        return false;
    }
};

export const extractDenom = (str) => {
    let res = str.replace(',', '').replace('원', '');
    return res;
};

export const addDenom = (int) => {
    let res = int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원';

    return res;
};

export const stringLineBreak = (str) => {
    return str.split('\n').map((line, i) => (
        <span key={`text${i}`}>
            {line}
            <br />
        </span>
    ));
};

export const callHiddenNav = () => {
    const menuClass = '.menu';
    const mainContentId = '#home';
    const bgDim = '.bg-dim'
    const bgElement = document.querySelector(bgDim)
    const menuElement = document.querySelector(menuClass)
    bgElement.classList.add('on')
    menuElement.classList.add('toggle')
    document.body.style.overflow = 'hidden'
    // $(bgDim).addClass('on');
    // $(menuClass).addClass('toggle');
    // $(mainContentId).addClass('back-blur');
    // $('body').css('overflow', 'hidden');
};

export const hideHiddenNav = () => {
    const menuClass = '.menu';
    const mainContentId = '#home';
    const bgDim = '.bg-dim'
    const bgElement = document.querySelector(bgDim)
    const menuElement = document.querySelector(menuClass)
    bgElement.classList.remove('on')
    menuElement.classList.remove('toggle')
    document.body.style.overflow = 'scroll'
    //
    // $(bgDim).removeClass('on');
    // $(menuClass).removeClass('toggle');
    // $(mainContentId).removeClass('back-blur');
    // $('body').css('overflow', 'scroll');
};

export const callChatPlugIn = () => {
    window.ChannelIO('showMessenger');
};

export const deleteCh = () => {
    const ch_plugin_launcher_element = document.getElementById('ch-plugin')
    if (ch_plugin_launcher_element) {
        window.ChannelIO('hideChannelButton');
    } else {
        setTimeout(deleteCh, 500)
    }
}

export const createCh = () => {
    const ch_plugin_launcher_element = document.getElementById('ch-plugin')
    if (ch_plugin_launcher_element) {
        window.ChannelIO('showChannelButton');
    }
}

export const parseCartData = (data) => {
    const itemArr = [];
    const giftItemArr = [];
    let totalCount = 0;


    for (const item of data.cartItems) {
        const dataToAdd = {
            id: item.cart_item_key,
            productId: item.product_id,
            slug: item.product && item.product.slug,
            name: item.product_name,
            thumbnail: item.product && item.product.images[0] && item.product.images[0].src,
            optionText: item.product_option_name,
            regularPrice: item.display_regular_price,
            price: item.display_price,
            discountRate: item.discount_rate,
            quantity: item.quantity,
            onSale: item.on_sale,
            variationThumbnail: item.variation_thumbnail,
            shippingAvailableToday: item.shipping_available_today,
            visible: item.product.visible,
            variationId: item.variation_id,
            isNpayAvailable: item.product.is_npay_available,
            additional_info: item?.product?.additional_info ? item.product.additional_info : item?.variation[0]?.additional_info ? item.variation[0].additional_info : null
        };

        // TODO: 아래 코드는 parse cart data에 있어서는 안
        if (item.wdr_free_product) {
            giftItemArr.push(dataToAdd);
        } else {
            itemArr.push(dataToAdd);
        }
        totalCount += item.quantity;
    }

    const newCartInfo = {
        cartItems: {
            normalItems: [],

            giftItems: [],
        },
        totalCount: 0,
    };
    newCartInfo.cartItems.normalItems = itemArr;
    newCartInfo.cartItems.giftItems = giftItemArr;
    newCartInfo.totalCount = totalCount;

    return newCartInfo;
};

export const parseMyCouponData = (myCouponData) => {
    // if (typeof myCouponData !== Array) return;
    const myCouponArr = [];
    if (myCouponData) {
        for (const item of myCouponData) {
            const dataToAdd = {
                id: item.id,
                expireDate: item.expiry_date,
                name: item.coupon_name,
                amount: item.coupon_amount,
                description: item.coupon_description,
                couponEffect: item.display_amount,
            };
            myCouponArr.push(dataToAdd);
        }
    }
    return myCouponArr;
};

export const checkFileType = (str, reg) => {
    if (str) {
        const fileExt = str.substring(str.lastIndexOf('.') + 1).toLowerCase();
        if (reg.test(fileExt) == false) {
            return false;
        } else {
            return true;
        }
    }
};

export const checkCSSHasSafeArea = () => {
    if (getComputedStyle(document.documentElement).getPropertyValue('--sabc').trim() !== '0px') {
        return true;
    } else if (
        getComputedStyle(document.documentElement).getPropertyValue('--sab').trim() !== '0px'
    ) {
        return true;
    } else {
        return false;
    }
};

export const moveScrollToElementIdSection = (id) => {
    const targetElement = document.getElementById(id)
    const targetElementOffset = targetElement.offsetTop
    window.scrollTo({ left: 0, top: targetElementOffset, behavior: 'smooth' })
}

export const moveScrollToElementIdSectionAuto = (id) => {
    const targetElement = document.getElementById(id)
    const targetElementOffset = targetElement.offsetTop - 200;
    window.scrollTo({ left: 0, top: targetElementOffset, behavior: "auto" })
}

export const moveBottomScrollToElementIdSection = (id) => {
    const targetElement = document.getElementById(id)
    const targetElementOffset = targetElement.scrollHeight
    window.scrollTo({ left: 0, top: targetElementOffset, behavior: 'smooth' })
}

export function moveToAccount() {
    window.location.href = '/account';
}

export function moveToCollection(collection) {
    window.location.href = '/collection/' + collection;
}

export function moveToSignup() {
    window.location.href = '/signup/menu';
}

export function moveToSignupForm() {
    window.location.href = '/signup/form';
}

export function moveToLogin() {
    window.location.href = '/login/menu';
}

export function moveToIncense() {
    window.location.href = '/product/collins-incense'
}

export function moveToLoginForm() {
    window.location.href = '/login/form';
}

export function logout() {
    fetchAndReceiveJSON({ url: apiUrl + '/api/logout', method: 'POST' }).then(() => window.location.href = '/')
    // location.href = '/logout';
}

export function linkToInsta() {
    window.open('https://www.instagram.com/collinslife_co/');
}

export function linkToYoutube() {
    window.open('https://www.youtube.com/channel/UCsjHhYwTMfBomzvsEb0fldQ');
}

export function linkToBrunch() {
    window.open('https://brunch.co.kr/@collinslife');
}

export function linkToSpotifyDirect() {
    window.open('https://open.spotify.com/playlist/4kCXNXC8kaTHsh8wRFsCK5?si=A6ewmI-IRe66UvniCHkhLw&nd=1&dlsi=109ff6489b774a1f');
}

export function linkToSpotify() {
    window.open('https://linktr.ee/collins_haveagoodnight');
}

export function moveToCollectionAll() {
    window.location.href = '/collection/all'
}

export function moveToBasicInfoUpdate() {
    window.location.href = '/account/basicinfo/form';
}

export function moveToShippingInfoUpdate() {
    window.location.href = '/account/shipping/form';
}

export function moveToPasswordUpdate() {
    window.location.href = '/account/password/form';
}

export function moveToOrder(id) {
    window.location.href = '/account/?orderId=' + id;
}

export function linkToMusic() {
    window.open('https://www.youtube.com/channel/UCsjHhYwTMfBomzvsEb0fldQ');
}

export function sendMail() {
    window.location.href = 'mailto:hello@collinslife.co';
}

export function moveToBack() {
    window.history.back();
}

export function validatePhonenum(num) {
    var phoneReg = /^\d{3}-\d{3,4}-\d{4}$/;
    return phoneReg.test(num);
}

export function validateCorpNum(num) {
    var phoneReg = /^\d{3}-\d{2}-\d{5}$/;
    return phoneReg.test(num);
}

export function phone_format(num) {
    var idx = -1;
    if (num.indexOf('+82') == 0) {
        idx = 3;
    }
    if (num.indexOf('82') == 0) {
        idx = 2;
    }
    if (idx > 0) {
        num = num.substr(idx);
        num = num.replace(/-/g, '');
        num = num.trim();
    }
    if (num.indexOf('0') != 0) {
        num = '0' + num;
    }
    return num.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
}

export function validateEmail(email) {
    if (email === '') {
        return false;
    }

    var emailReg = /^([\w-]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test(email);
}

//# sourceMappingURL=main.js.map

export function openChannelIO() {
    window.ChannelIO('showMessenger')
}

export function openPlusKakao() {
    window.open('http://pf.kakao.com/_FZkcxb');
}


const overlayBackClass = '.overlay-back';
const overlayToggleClass = 'overlay-toggle';

export function showOverlay(id) {
    const targetElement = document.querySelector(id)
    const overlayBackElement = document.querySelector(overlayBackClass)
    targetElement.classList.add(overlayToggleClass)
    overlayBackElement.classList.add(overlayToggleClass)
}

export function hideOverlay(id) {
    const targetElement = document.querySelector(id)
    const overlayBackElement = document.querySelector(overlayBackClass)
    targetElement.classList.remove(overlayToggleClass)
    overlayBackElement.classList.remove(overlayToggleClass)
}

export const isHasCustomTapProduct = (slug) => {
    if (!slug) {
        return false;
    }

    return slug.includes("incense-list") || slug.includes("collins-incense") || slug.includes("keyring-honeybadger") || slug.includes("secret-wish-set")
        || slug.includes("incense-roomno11-pr2404") || slug.includes("incense-donotdisturb-pr2404") || slug.includes("incense-welcomedrink-pr2404")
        || slug.includes("incense-splashdiving-pr2404") || slug.includes("incense-fluffypillow-pr2404") || slug.includes("incense-goodtimes-pr2404")
        || slug.includes("incense-goodtimes-set-b-pr2404") || slug.includes("incense-goodtimes-set-a-pr2404")
        || slug.includes("moodwater-yuja") || slug.includes("moodwater-violet") || slug.includes("moodwater-juniper") || slug.includes('moodwater-variety-3')
        || slug.includes('mood-soap-3scents') || slug.includes('collins-incense-mix')
        || slug.includes("moodwater-60-yuja") || slug.includes("moodwater-60-violet") || slug.includes("moodwater-60-juniper") || slug.includes("moodwater-60-variety-3") || slug.includes("collins-sachets") || slug.includes("collins-incense-mindxmood") || slug.includes("incense-love-set")
        || slug.includes("incense-wish2026-set-1") || slug.includes("incense-wish2026-set-2");
}


export function downloadCSV(data, filename, mime) {
    const blob = new Blob(["\uFEFF" + data], { type: mime || 'application/octet-stream' });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
        }

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        window.URL.revokeObjectURL(blobURL);
    }
}

export const SetScreenSize = () => {
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
}

export const convertMonth = (month) => {
    if (month === 0) {
        return "JAN"
    } else if (month === 1) {
        return "FEB"
    } else if (month === 2) {
        return "MAR"
    } else if (month === 3) {
        return "APR"
    } else if (month === 4) {
        return "MAY"
    } else if (month === 5) {
        return "JUNE"
    } else if (month === 6) {
        return "JULY"
    } else if (month === 7) {
        return "AUG"
    } else if (month === 8) {
        return "SEPT"
    } else if (month === 9) {
        return "OCT"
    } else if (month === 10) {
        return "NOV"
    } else if (month === 11) {
        return "DEV"
    }
}

export const convertMonthV2 = (month) => {
    if (month === 0) {
        return "Jan"
    } else if (month === 1) {
        return "Feb"
    } else if (month === 2) {
        return "Mar"
    } else if (month === 3) {
        return "Apr"
    } else if (month === 4) {
        return "May"
    } else if (month === 5) {
        return "Jun"
    } else if (month === 6) {
        return "Jul"
    } else if (month === 7) {
        return "Aug"
    } else if (month === 8) {
        return "Sep"
    } else if (month === 9) {
        return "Oct"
    } else if (month === 10) {
        return "Nov"
    } else if (month === 11) {
        return "Dec"
    }
}

const EMOJIS_REGEX = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
export const removeEmojis = (str) => {
    return str.replace(EMOJIS_REGEX, "")
}
export const getSessionStorage = (key) => {
    return window.sessionStorage.getItem(key)
}

export const setSessionStorage = (key, item) => {
    window.sessionStorage.setItem(key, item)
}

export const checkDate = () => {
    const startDate = new Date(2022, 8, 7, 0)
    const endDate = new Date(2022, 8, 12, 15)

    const today = new Date()
    if (startDate > today || endDate < today) {
        return false
    } else {
        return true
    }
}
export const filterThumbnailImageByFormat = (images) => {
    const imageMap = new Map()
    images.map(image => {
        const splitImagePath = image.src.split('/');
        const splitImageName = splitImagePath[splitImagePath.length - 1].split('.');
        const format = splitImageName[splitImageName.length - 1];
        splitImageName.pop()
        const fileName = splitImageName.join('.');
        const imagePath = splitImagePath.join('/');
        if (imageMap.has(fileName)) {
            imageMap.get(fileName).set(format, imagePath)
        } else {
            imageMap.set(fileName, new Map().set('type', image.type))
            imageMap.get(fileName).set(format, imagePath)
        }

    })
    return imageMap
}


export const categoryNameTranslateKR = (categoryName) => {
    if (categoryName === 'fragrance') {
        return '프래그런스'
    } else if (categoryName === 'homewear') {
        return '홈웨어'
    } else if (categoryName === 'hygiene') {
        return '청결용품'
    } else if (categoryName === 'goods') {
        return '브랜드 굿즈'
    } else if (categoryName === 'gift') {
        return '기프트'
    } else if (categoryName === 'all') {
        return '모든 제품'
    } else if (categoryName === "goodby1pulus1") {
        return '굿바이 1+1'
    } else {
        return ""
    }
}

export const UnUsedFooterPageList = [
    "product", "brandstory", "form"
]

export const LimitedListId = [
    199937, 34136, 34138, 34137, 34139, 34140
]

export const removeIdDuringCollinsDay = [
    34135, 87158, 107246, 116198, 199936, 199935, 199934
]

export const limitNumberOfItemInCart = async (limitItems, currentCount, limitCount, currentItems, cartPage = false) => {
    let count = 0;
    if (!currentCount) {
        currentCount = 0
    }
    await Promise.all(currentItems?.map(item => {
        if (limitItems.some(limitItem => limitItem === item?.id || limitItem === item?.variationId || limitItem === item?.variation_id)) {
            count += item.quantity
        }
    }))

    if (cartPage || currentCount === 0) {
        return count > limitCount;
    } else {
        if (count + currentCount > limitCount) {
            const items = await fetch(`${apiUrl}/api/cart/item`, {
                method: 'get',
                credentials: 'include'
            })

            const data = await items.json()
            await Promise.all(data?.cartItems?.map(item => {
                if (limitItems.some(limitItem => limitItem === item.variation_id)) {
                    count += item.quantity;
                }
            }))
            return count > limitCount;
        } else {
            return false
        }
    }

}

export const msToHMS = (ms) => {
    // 1- Convert to seconds:
    let seconds = ms / 1000;
    // 2- Extract hours:
    const hours = parseInt(String(seconds / 3600)); // 3,600 seconds in 1 hour
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    const minutes = parseInt(String(seconds / 60)); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = Math.floor(seconds % 60);
    return (hours + "시간 " + minutes + "분 " + seconds + "초 ");
}

export const msToDHM = (ms) => {
    // 1- Convert to seconds:
    let seconds = ms / 1000;
    // 2- Extract hours:
    const days = Number(parseInt(String(seconds / 3600 / 24)))
    seconds = seconds - (days * 24 * 3600);
    const hours = Number(parseInt(String(seconds / 3600))); // 3,600 seconds in 1 hour
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    const minutes = Math.ceil(seconds / 60); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    const text = `${(days > 0 ? days + "일 " : '') + (hours > 0 || days > 0 ? hours + "시간 " : '') + `${minutes}분`}`
    return text;
}

export default function useIntersectionObserver(callback, error) {
    const observer = useRef(
        new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback();
                    } else {
                        if (error) {
                            error()
                        }
                    }
                });
            },
            { threshold: 1, rootMargin: "80px 0px" }
        )
    );

    const observe = (element) => {
        observer.current.observe(element);
    };

    const unobserve = (element) => {
        observer.current.unobserve(element);
    };

    return [observe, unobserve];
}


export const convertImgFormat = (imgMap) => {
    if (imgMap.get('webp')) {
        return imgMap.get('webp')
    } else if (imgMap.get('png')) {
        return imgMap.get('png')
    } else if (imgMap.get('jpg')) {
        return imgMap.get('jpg')
    } else if (imgMap.get('gif')) {
        return imgMap.get('gif')
    }
}
